import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: false,
};

export const SidebarSlice = createSlice({
  name: "CurrentChatUser",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, setStatus } = SidebarSlice.actions;

export default SidebarSlice;
